const FinanceOptionDivider: React.FunctionComponent = function () {
  return (
    <div className="border-b last:border-0 border-neutral-300 -mx-3 md:-mx-4 col-span-3" />
  );
};

export default FinanceOptionDivider;
